/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {
  ChangeEvent,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import axios from 'axios';
import * as Yup from 'yup';
import Swal from 'sweetalert2';

import { useHistory, useParams } from 'react-router-dom';
import { IoMdClose } from 'react-icons/io';
import { MdUpload } from 'react-icons/md';
import api from '~/services/api';
import getValidationErros from '~/utils/getValidationsErrors';

import { Container } from './styles';
import Loading from '~/components/Loading';
import InputMask from '~/components/InputMask';
import Input from '~/components/Input';
import Toast from '~/utils/toast';

interface ISponsor {
  id: number;
  name: string;
  email: string;
  logo: {
    id: number;
    name: string;
    archive_url: string;
  };
  company: {
    id: number;
    document: string;
    name: string;
    fantasy_name: string;
    support_email: string;
    finance_email: string;
    address: {
      id: number;
      zip_code: string;
      street: string;
      number: string;
      city: string;
      state: string;
      neighborhood: string;
      complement: string;
    };
  };
}

interface IFormData {
  sponsor_id: number;
  archive_id: number;
  company_id: number;
  name: string;
  cnpj: string;
  company_name: string;
  fantasy_name: string;
  contact_email: string;
  address_id: number;
  zipcode: string;
  street: string;
  number: string;
  city: string;
  state: string;
  neighborhood: string;
  complement: string;
}

interface IParams {
  sponsor_id: string;
}

interface IFile {
  id: number;
  name: string;
  url: string;
}

const UpdateSponsor: React.FC = () => {
  const params = useParams<IParams>();
  const [progressNumber, setProgressNumber] = useState(1);
  const formRef = useRef<FormHandles>(null);
  const history = useHistory();
  const [filesInfo, setFilesInfo] = useState<File[]>([]);
  const [oldFilesInfo, setOldFilesInfo] = useState({} as IFile);
  const [oldFilesInfoDeleted, setOldFilesInfoDeleted] = useState({} as IFile);
  const [loading, setLoading] = useState(false);
  const [companyName, setCompanyName] = useState('');
  const [fantasyName, setFantasyName] = useState('');
  const [email, setEmail] = useState('');
  const [zipcode, setZipcode] = useState('');
  const [street, setStreet] = useState('');
  const [number, setNumber] = useState('');
  const [state, setState] = useState('');
  const [city, setCity] = useState('');
  const [neighborhood, setNeighborhood] = useState('');
  const [complement, setComplement] = useState('');
  const [sponsor, setSponsor] = useState({} as IFormData);

  const progress = useMemo(() => [1, 2], []);

  const textProgress = useMemo(
    () => [{ name: 'Empresa' }, { name: 'Endereço' }],
    []
  );

  useEffect(() => {
    api.get<ISponsor>(`sponsors/${params.sponsor_id}`).then((response) => {
      const data: IFormData = {
        sponsor_id: response.data.id,
        archive_id: response.data.logo.id,
        company_id: response.data.company.id,
        name: response.data.name,
        cnpj: response.data.company.document,
        company_name: response.data.company.name,
        fantasy_name: response.data.company.fantasy_name,
        contact_email: response.data.company.support_email,
        address_id: response.data.company.address.id,
        zipcode: response.data.company.address.zip_code,
        street: response.data.company.address.street,
        number: response.data.company.address.number,
        city: response.data.company.address.city,
        state: response.data.company.address.state,
        neighborhood: response.data.company.address.neighborhood,
        complement: response.data.company.address.complement,
      };
      setOldFilesInfo({
        id: response.data.logo.id,
        name: response.data.logo.name,
        url: response.data.logo.archive_url,
      });
      setSponsor(data);
      setCompanyName(response.data.company.name);
      setFantasyName(response.data.company.fantasy_name);
      setEmail(response.data.company.support_email);
      setZipcode(response.data.company.address.zip_code);
      setStreet(response.data.company.address.street);
      setNumber(response.data.company.address.number);
      setState(response.data.company.address.state);
      setCity(response.data.company.address.city);
      setNeighborhood(response.data.company.address.neighborhood);
      setComplement(response.data.company.address.complement);
    });
  }, [params.sponsor_id]);

  const handleClickNext = useCallback((stepSelected) => {
    setProgressNumber(stepSelected);
  }, []);

  const handleChangeCnpj = useCallback(async (e) => {
    const { value } = e.target;
    if (value.length === 18) {
      const response = await axios.get(
        `https://publica.cnpj.ws/cnpj/${value
          .replaceAll('.', '')
          .replaceAll('-', '')
          .replaceAll('/', '')}`
      );
      setCompanyName(response.data.razao_social);
      setFantasyName(response.data.estabelecimento.nome_fantasia);
      setEmail(response.data.estabelecimento.email);
      setZipcode(response.data.estabelecimento.cep);
      setStreet(
        `${response.data.estabelecimento.tipo_logradouro} ${response.data.estabelecimento.logradouro}`
      );
      setNumber(response.data.estabelecimento.numero);
      setState(response.data.estabelecimento.estado.sigla);
      setCity(response.data.estabelecimento.cidade.nome);
      setNeighborhood(response.data.estabelecimento.bairro);
      setComplement(response.data.estabelecimento.complemento);
    }
  }, []);

  const handleSponsorName = useCallback((e) => {
    setCompanyName(e.target.value);
  }, []);

  const handleSponsorFantasy = useCallback((e) => {
    setFantasyName(e.target.value);
  }, []);

  const handleSuppotyEmail = useCallback((e) => {
    setEmail(e.target.value);
  }, []);

  const handleChangeZipCode = useCallback(async (e) => {
    const { value } = e.target;
    setZipcode(value);

    if (value.length === 9) {
      const response = await axios.get(
        `https://viacep.com.br/ws/${value}/json/`
      );
      setStreet(response.data.logradouro);
      setNumber('');
      setState(response.data.uf);
      setCity(response.data.localidade);
      setNeighborhood(response.data.bairro);
      setComplement(response.data.complemento);
    }
  }, []);

  const handleChangeStreet = useCallback((e) => {
    setStreet(e.target.value);
  }, []);

  const handleChangeNumber = useCallback((e) => {
    setNumber(e.target.value);
  }, []);

  const handleChangeCity = useCallback((e) => {
    setCity(e.target.value);
  }, []);

  const handleChangeState = useCallback((e) => {
    setState(e.target.value);
  }, []);

  const handleChangeNeighborhood = useCallback((e) => {
    setNeighborhood(e.target.value);
  }, []);

  const handleChangeComplement = useCallback((e) => {
    setComplement(e.target.value);
  }, []);

  const handleSubmit = useCallback(
    async (data: IFormData) => {
      try {
        setLoading(true);
        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          name: Yup.string().required('O nome do patrocinador é obrigatório'),
          cnpj: Yup.string().required('O CNPJ é obrigatório'),
          company_name: Yup.string().required('A razão social é obrigatória'),
          fantasy_name: Yup.string().required('O nome fantasia é obrigatório'),
          contact_email: Yup.string().required(
            'O e-mail de contato é obrigatório'
          ),
          zipcode: Yup.string().required('O CEP é obrigatório'),
          street: Yup.string().required('A rua é obrigatória'),
          number: Yup.string().required('O número é obrigatório'),
          city: Yup.string().required('A cidade é obrigatória'),
          state: Yup.string().required('O estado é obrigatório'),
          neighborhood: Yup.string().required('O bairro é obrigatório'),
          complement: Yup.string(),
          files: Yup.string().test(
            'validLogo',
            `O logotipo é obrigatório`,
            () => {
              return (
                filesInfo.length > 0 || Object.keys(oldFilesInfo).length > 0
              );
            }
          ),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        const addressFormData = {
          street: data.street,
          number: data.number,
          neighborhood: data.neighborhood,
          city: data.city,
          state: data.state,
          country: 'BR',
          complement: data.complement,
          zip_code: data.zipcode,
        };

        const responseAddress = await api.put(
          `addresses/${sponsor.address_id}`,
          addressFormData
        );

        const companyFormData = {
          address_id: responseAddress.data.id,
          document: data.cnpj,
          name: data.company_name,
          fantasy_name: data.fantasy_name,
          support_email: data.contact_email,
          finance_email: data.contact_email,
        };

        const responseCompany = await api.put(
          `companies/organizers/${sponsor.company_id}`,
          companyFormData
        );

        let { archive_id } = sponsor;

        if (filesInfo.length > 0) {
          const logoFormData = new FormData();
          logoFormData.append('file', filesInfo[0]);

          const responseLogo = await api.post(
            'archives/organizers',
            logoFormData
          );

          archive_id = responseLogo.data.id;
        }

        if (Object.keys(oldFilesInfoDeleted).length > 0) {
          await api.delete(`archives/organizers/${oldFilesInfoDeleted.id}`);
        }

        const formData = {
          archive_id,
          company_id: responseCompany.data.id,
          name: data.name,
          email: data.contact_email,
        };

        await api.put(`sponsors/${sponsor.sponsor_id}`, formData);

        Toast.fire({
          icon: 'success',
          iconColor: '#ff6900',
          title: 'Patrocinador editado com sucesso!',
        });

        history.push(`${process.env.PUBLIC_URL}/patrocinadores`);
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErros(error);

          formRef.current?.setErrors(errors);
        } else {
          Swal.fire('Oops...', 'Ocorreu um erro tente novamente, por favor');
        }
      } finally {
        setLoading(false);
      }
    },
    [filesInfo, history, oldFilesInfo, oldFilesInfoDeleted, sponsor]
  );

  const handleDrop = useCallback(
    (event: React.DragEvent<HTMLLabelElement>) => {
      event.preventDefault();
      if (Object.keys(oldFilesInfo).length > 0) {
        setOldFilesInfoDeleted(oldFilesInfo);
        setOldFilesInfo({} as IFile);
      }
      const { files } = event.dataTransfer;
      if (files) {
        setFilesInfo(() => [...Array.from(files)]);
      }
    },
    [oldFilesInfo]
  );

  const handleDragOver = useCallback(
    (event: React.DragEvent<HTMLLabelElement>) => {
      event.preventDefault();
    },
    []
  );

  const handleFileChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      if (Object.keys(oldFilesInfo).length > 0) {
        setOldFilesInfoDeleted(oldFilesInfo);
        setOldFilesInfo({} as IFile);
      }
      const { files: filesData } = event.target;

      if (filesData) {
        if (
          filesData[0].type !== 'image/jpeg' &&
          filesData[0].type !== 'image/png' &&
          filesData[0].type !== 'image/svg+xml'
        ) {
          Swal.fire({
            icon: 'error',
            iconColor: '#ff6900',
            confirmButtonColor: '#ff6900',
            title: 'Formato inválido',
            text: 'O arquivo deve ser do formato JPG, JPEG, PNG ou SVG',
          });
        } else if (filesData[0].size > 50000) {
          Swal.fire({
            icon: 'error',
            iconColor: '#ff6900',
            confirmButtonColor: '#ff6900',
            title: 'Arquivo muito grande',
            text: 'O tamanho do arquivo deve ser menor que 50KB',
          });
        } else {
          setFilesInfo(() => [...Array.from(filesData)]);
        }
      }
    },
    [oldFilesInfo]
  );

  const handleDelete = useCallback((indexToDelete) => {
    setFilesInfo((prevFiles) =>
      prevFiles.filter((file, index) => index !== indexToDelete)
    );
  }, []);

  const handleDeleteFile = useCallback(() => {
    setOldFilesInfoDeleted(oldFilesInfo);
    setOldFilesInfo({} as IFile);
  }, [oldFilesInfo]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [progressNumber]);

  return (
    <Container>
      <div className="container-fluid">
        <div>
          <div className="row">
            <div className="col-12 px-0">
              <div className="bg-white d-flex justify-content-between align-items-center p-4">
                <h1 className="mb-0">Editar Patrocinador</h1>
              </div>
            </div>
            <div className="col-12 px-0">
              <div className="bg-white p-4 p-lg-5 mt-3">
                <div className="row justify-content-center">
                  <div className="col-xl-10 col-xxl-9">
                    <div className="d-flex justify-content-center align-items-center">
                      {progress.map((index) => (
                        <>
                          <div>
                            <div className="pe-none btn bg-transparent border-0 position-relative">
                              <span
                                className={`${
                                  index < progressNumber + 1
                                    ? 'circle-active'
                                    : 'circle'
                                }`}
                              >
                                {index}
                              </span>

                              <span
                                className={`text ${
                                  index < progressNumber + 1
                                    ? 'text-active'
                                    : ''
                                }`}
                              >
                                {textProgress[index - 1].name}
                              </span>
                            </div>
                          </div>
                          {index !== progress.length && (
                            <hr
                              className={`${
                                index < progressNumber + 1 && 'hr-active'
                              } w-22 my-0 mx-2`}
                            />
                          )}
                        </>
                      ))}
                    </div>
                  </div>
                </div>
                <Form
                  ref={formRef}
                  onSubmit={handleSubmit}
                  className="row justify-content-center"
                  initialData={sponsor}
                >
                  <div className="col-lg-9 col-xl-7 col-xxl-6">
                    <div
                      className={`${
                        progressNumber === 1 ? 'd-block' : 'd-none'
                      }`}
                    >
                      <h2 className="h4 fw-semibold pt-4 mt-5 mb-4">
                        1 - Empresa
                      </h2>
                      <div className="row">
                        <div className="col-12">
                          <h3 className="h6 fw-normal">Nome do patrocinador</h3>
                          <Input name="name" className="input" />
                        </div>
                        <div className="col-12">
                          <h3 className="h6 fw-normal mt-3">CNPJ</h3>
                          <InputMask
                            kind="cnpj"
                            name="cnpj"
                            onChange={(e) => handleChangeCnpj(e)}
                            className="input"
                            value={sponsor.cnpj}
                          />
                        </div>
                        <div className="col-12">
                          <h3 className="h6 fw-normal mt-3">Razão Social</h3>
                          <Input
                            name="company_name"
                            value={companyName}
                            onChange={(e) => handleSponsorName(e)}
                            className="input"
                          />
                        </div>
                        <div className="col-12">
                          <h3 className="h6 fw-normal mt-3">Nome Fantasia</h3>
                          <Input
                            name="fantasy_name"
                            value={fantasyName}
                            onChange={(e) => handleSponsorFantasy(e)}
                            className="input"
                          />
                        </div>
                        <div className="col-12">
                          <h3 className="h6 fw-normal mt-3">E-mail</h3>
                          <Input
                            type="email"
                            name="contact_email"
                            value={email}
                            onChange={(e) => handleSuppotyEmail(e)}
                            className="input"
                          />
                        </div>
                        <div className="col-12 mt-3">
                          <h3 className="h6 fw-normal">Logotipo</h3>
                          <label
                            htmlFor="fileInput"
                            className="w-100 text-center"
                            onDrop={handleDrop}
                            onDragOver={handleDragOver}
                          >
                            <MdUpload size={48} color="#FF6900" />
                            <span className="d-block">
                              Arraste e solte o arquivo aqui para
                              <br />
                              adicionar a imagem
                            </span>
                            <span className="d-inline-flex my-2">
                              Seleciona Imagem
                            </span>
                            <span className="d-block">
                              Extensões aceitas: jpg, png, jpeg.
                            </span>
                          </label>
                          <Input
                            id="fileInput"
                            type="file"
                            name="files"
                            className="d-none"
                            onChange={handleFileChange}
                          />
                          {Object.keys(oldFilesInfo).length > 0 && (
                            <div className="d-flex justify-content-between arquives p-3 mt-3">
                              <div className="d-flex align-items-center">
                                <img
                                  src={oldFilesInfo.url}
                                  alt={oldFilesInfo.name}
                                />
                                <p className="ms-3 mb-0">{oldFilesInfo.name}</p>
                              </div>
                              <button
                                type="button"
                                className="bg-transparent border-0"
                                onClick={handleDeleteFile}
                              >
                                <IoMdClose size={24} color="#8C8C8C" />
                              </button>
                            </div>
                          )}
                          {filesInfo.map((file, index) => (
                            <div
                              // eslint-disable-next-line react/no-array-index-key
                              key={index}
                              className="d-flex justify-content-between arquives p-3 mt-3"
                            >
                              <div className="d-flex align-items-center">
                                <img
                                  src={URL.createObjectURL(file)}
                                  alt={file.name}
                                />
                                <p className="ms-3 mb-0">{file.name}</p>
                              </div>
                              <button
                                type="button"
                                className="bg-transparent border-0"
                                onClick={() => handleDelete(index)}
                              >
                                <IoMdClose size={24} color="#8C8C8C" />
                              </button>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                    <div
                      className={`${
                        progressNumber === 2 ? 'd-block' : 'd-none'
                      }`}
                    >
                      <h2 className="h4 fw-semibold pt-4 mt-5 mb-4">
                        2 - Endereço
                      </h2>
                      <div className="row">
                        <div className="col-lg-4">
                          <h3 className="h6 fw-normal">CEP</h3>
                          <InputMask
                            kind="zip-code"
                            name="zipcode"
                            value={zipcode}
                            onChange={(e) => handleChangeZipCode(e)}
                            className="input"
                          />
                        </div>
                        <div className="col-lg-8 mt-3 mt-lg-0">
                          <h3 className="h6 fw-normal">Endereço</h3>
                          <Input
                            name="street"
                            value={street}
                            onChange={(e) => handleChangeStreet(e)}
                            className="input"
                          />
                        </div>
                        <div className="col-lg-2 mt-3">
                          <h3 className="h6 fw-normal">Número</h3>
                          <Input
                            name="number"
                            value={number}
                            onChange={(e) => handleChangeNumber(e)}
                            className="input"
                          />
                        </div>
                        <div className="col-lg-5 mt-3">
                          <h3 className="h6 fw-normal">Cidade</h3>
                          <Input
                            name="city"
                            value={city}
                            onChange={(e) => handleChangeCity(e)}
                            className="input"
                          />
                        </div>
                        <div className="col-lg-5 mt-3">
                          <h3 className="h6 fw-normal">Estado</h3>
                          <Input
                            name="state"
                            value={state}
                            onChange={(e) => handleChangeState(e)}
                            className="input"
                          />
                        </div>
                        <div className="col-lg-5 mt-3">
                          <h3 className="h6 fw-normal">Bairro</h3>
                          <Input
                            name="neighborhood"
                            value={neighborhood}
                            onChange={(e) => handleChangeNeighborhood(e)}
                            className="input"
                          />
                        </div>
                        <div className="col-lg-7 mt-3">
                          <h3 className="h6 fw-normal">Complemento</h3>
                          <Input
                            name="complement"
                            value={complement}
                            onChange={(e) => handleChangeComplement(e)}
                            className="input"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </Form>
                <div className="row justify-content-center">
                  <div className="col-lg-6 d-flex mt-4 justify-content-center">
                    {progressNumber !== 1 && (
                      <button
                        type="button"
                        onClick={() => setProgressNumber(progressNumber - 1)}
                        className="mb-0 me-4 h6 fw-normal btn-back px-5 py-2 mt-2"
                      >
                        Anterior
                      </button>
                    )}

                    <button
                      type="button"
                      onClick={() => {
                        progressNumber === 2
                          ? formRef.current?.submitForm()
                          : handleClickNext(progressNumber + 1);
                      }}
                      className="mb-0 h6 fw-normal text-white btn-new px-5 py-2 mt-2"
                    >
                      {progressNumber === 2 ? 'Salvar' : 'Próximo'}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Loading active={loading} text="Salvando..." />
    </Container>
  );
};

export default UpdateSponsor;
